export function registerCacheWorker() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .register("/cache-worker.js")
      .then(() => {})
      .catch((err) => {
        console.error("Service Worker registration failed: ", err);
      });
  }
}
